import { render, staticRenderFns } from "./SendGridBtn.vue?vue&type=template&id=0f56ee23&"
import script from "./SendGridBtn.vue?vue&type=script&lang=js&"
export * from "./SendGridBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports